import {ChangeDetectionStrategy, Component, Input, OnChanges} from '@angular/core';
import {CommonModule} from '@angular/common';
import {Q9HtmlEncoderPipe} from '@q9elements/ui-kit/common';
import {VersionTreeNode} from 'src/app/core/services/map-tree.service';
import {ScreenshotConfig} from 'src/app/shared/ui/screenshot-popover/models/screenshot-config';
import {ScreenshotPopoverDirective} from 'src/app/editor-interface/shared/directives/screenshot-popover.directive';

@Component({
  selector: 'app-map-tree-node',
  templateUrl: './map-tree-node.component.html',
  styleUrls: ['./map-tree-node.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, Q9HtmlEncoderPipe, ScreenshotPopoverDirective]
})
export class MapTreeNodeComponent implements OnChanges {
  @Input() node: VersionTreeNode;

  public scrConfig: ScreenshotConfig;

  public level: string;

  ngOnChanges() {
    this.prepareNodeData();
  }

  prepareNodeData() {
    let levelStr = this.node.level;
    const temp = this.node.level.split('.');

    if (temp.length > 10) {
      levelStr = `${temp.slice(0, 5).join('.')}... ${temp.length - 10}+...${temp.slice(-5).join('.')}`;
    }

    this.level = levelStr;
    this.scrConfig = {id: this.node.id, state: this.node.version};
  }
}
